import React, { useState, useEffect } from "react";
import DefaultTabList from "../../components/CategoryTab/DefaultTabList";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import bgImage from "../../assets/img/03_main_banner.png";
import { useLanguage } from "../../hooks/useLanguage";

function About(){
  const [isMobile, setIsMobile] = useState(false); // 모바일에서 스와이퍼 작동
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);


  const tabList = [
    { value: 'intro', name: t('about_us') },
    { value: 'history', name: t('company_history') },
    { value: 'branch', name: t('branch_info') },
    { value: 'guide', name: t('reservation_guide') },
    { value: 'information', name: t('usage_guide') },
    { value: 'terms', name: t('terms_of_service') },
    { value: 'benefits', name: t('discount_info') },
  ];

  const activeTab = tabList.find(tab => location.pathname.includes(tab.value))?.value || 'intro';

  const handleActive = (tab) => {
    navigate(`/about/${tab.value}`);
  };

  // 현재 탭에 따른 배너 설명 텍스트 설정
  const getBannerDesc = () => {
    switch(activeTab) {
      case 'intro':
        return t('about_us_desc');
      case 'history':
        return t('company_history_desc');
      case 'branch':
        return t('branch_info_desc');
      case 'guide':
        return t('reservation_guide_desc');
      case 'information':
        return t('usage_guide_desc');
      case 'terms':
        return t('terms_of_service_desc');
      case 'benefits':
        return t('discount_info_desc');
      default:
        return t('about_us_desc');
    }
  };

  const bannerDesc = getBannerDesc();


  return(
    <div>
      <section className="comm_section">
        {/* 배너 */}
        <div 
          className="comm_banner"
          style={{backgroundImage:`url(${bgImage})`}}
        >
          <div className="comm_banner_inner">
            <h4>About Us</h4>
            <p>{bannerDesc}</p>
          </div>
        </div>

        {/* 탭 */}
        <DefaultTabList
          tabList={tabList}
          activeValue={activeTab}
          isEnabledSwiper={isMobile}
          handleActive={handleActive}
        />

        <div className="comm_inner">
          <Outlet/>
        </div> 



      </section>

    </div>

  )
};

export default About; 
